import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
/**
 * Horario EFECTIVO del alumno (GET /schedules/me/effective): clases
 * publicadas de su turno + comunes a la oposición, con sus cambios activos
 * (turno temporal y clase puntual) aplicados por el backend — misma
 * semántica que el pase de lista.
 */
export function useStudentSchedule(month, year) {
    const query = useQuery({
        queryKey: ['student-schedule-effective', month, year],
        queryFn: () => apiClient(`/schedules/me/effective?month=${month}&year=${year}`),
        staleTime: 1000 * 60 * 5,
    });
    return {
        schedule: query.data,
        isLoading: query.isLoading,
        isError: query.isError,
    };
}
//# sourceMappingURL=useStudentSchedule.js.map